import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { setBillinPlanSelectorMode } from 'redux/billing/actions';

import './PlanModeSelector.css';

class PlanModeSelector extends Component {
  static propTypes = {
    setBillinPlanSelectorMode: PropTypes.func.isRequired,
    setPlanMode: PropTypes.func.isRequired,
    initialMode: PropTypes.string,
    billingPlanSelectorMode: PropTypes.string.isRequired,
  };

  static defaultProps = {
    initialMode: null,
  };

  componentDidMount() {
    if (this.props.initialMode) {
      this.props.setPlanMode(this.props.initialMode);
      this.props.setBillinPlanSelectorMode(this.props.initialMode);
    } else {
      this.props.setPlanMode(this.props.billingPlanSelectorMode);
    }
  }

  toggleMode = () => {
    if (this.props.billingPlanSelectorMode === 'year') {
      this.props.setPlanMode('month');
      this.props.setBillinPlanSelectorMode('month');
    } else {
      this.props.setPlanMode('year');
      this.props.setBillinPlanSelectorMode('year');
    }
  }

  render() {
    const { billingPlans, billingPlanSelectorMode } = this.props;

    if (!billingPlans) return null;

    const proPlan = billingPlans && billingPlans.filter(plan => plan.title === 'Pro')[0];

    return (
      <Translation>
        {(t) => (
          <div className="plan-mode-selector__component">
            <div className="discount-label">{t("SAVE")} {proPlan.annual_price_discount}%</div>
            <div
              className={`mode-item${billingPlanSelectorMode === 'year' ? ' active' : ''}`}
              onClick={this.toggleMode}
              role="button"
              tabIndex={-1}
            >
              {t("Yearly")}
            </div>
            <div
              className={`mode-item${billingPlanSelectorMode === 'month' ? ' active' : ''}`}
              onClick={this.toggleMode}
              role="button"
              tabIndex={-1}
            >
              {t("Monthly")}
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    billingPlans: state.billingReducer.billingPlans,
    billingPlanSelectorMode: state.billingReducer.billingPlanSelectorMode
  }
);

export default connect(
  mapStateToProps,
  {
    setBillinPlanSelectorMode,
  },
)(PlanModeSelector);
